import React, {PureComponent} from 'react';
import PropTypes from "prop-types";

import {makeStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

import TextUtil from '../util/TextUtil';
import CardMedia from "@material-ui/core/CardMedia";
import DpaLinkItem from "./DpaLinkItem";

import "../fgfStyles.css";
import DetectLocale from "../util/DetectLocale";

const useStyles = makeStyles((_) => ({
    infosCard: {},
    title_h1: {
        color: '#000000',
        marginBottom: 16,
        fontWeight: 500,
        fontSize: 34,
        fontFamily: "DinforPBR",
        letterSpacing: "-0.5px",
        lineHeight: 38/34,
    },
    title_h2: {
        color: '#000000',
        marginBottom: 16,
        fontWeight: 500,
        fontSize: 24,
        fontFamily: "DinforPBR",
        letterSpacing: 0.0,
        lineHeight: 1.2,
    },
    kicker: {
        color: '#666666',
        marginBottom: 8,
        fontWeight: 500,
        fontSize: 14,
        letterSpacing: 18/14,
        fontFamily: "DinforPBR",
    },
    creditline: {
        color: '#757575',
        marginBottom: 18,
        fontWeight: 400,
        fontSize: 12,
        fontFamily: "DinforPBR",
        lineHeight: "16px"
    },
    caption: {
        color: '#000000',
        fontWeight: 400,
        fontSize: 14,
        fontFamily: "DinforPBR",
        lineHeight: "18px"
    },
    creditline_inline: {
        color: '#757575',
        marginBottom: 18,
        fontWeight: 400,
        fontSize: 12,
        fontFamily: "DinforPBR",
        paddingTop: 8
    },
    caption_inline: {
        color: '#000000',
        fontWeight: 400,
        fontSize: 14,
        fontFamily: "DinforPBR",
        paddingTop: "1em",
        lineHeight: "18px"

    },
    teaser: {
        color: '#000000',
        fontWeight: 900,
        fontSize: 16,
        fontFamily: "DinforPBR",
        lineHeight: "21px"
    },
    divider: {
        height: 2,
        backgroundColor: '#f3f1f3',
        marginBottom: 8,
    },
    list: {
        marginBottom: 6,
    },
    p: {
        color: '#000000',
        fontWeight: 400,
        fontSize: 16,
        fontFamily: "DinforPBR",
        lineHeight: 21/16
    }
}));

class DpaInfoCard extends PureComponent {

    render() {
        const {classes, entry, full, userLang} = this.props;



        const article = this.getArticle();
        const title = TextUtil.isEmptyText(article.title) ? "" : TextUtil.relaceQuotationMarks(article.title);
        const kicker = TextUtil.isEmptyText(article.kicker) ? "" : TextUtil.relaceQuotationMarks(article.kicker.toUpperCase());

        let creditline = null;
        let caption = null;
        let firstImage = this.getFirstImage();
        if (firstImage) {
            if(firstImage.creditline) {
                creditline = <Typography
                    variant='title'
                    component='h3'
                    classes={{root: classes.creditline}}
                >

                    {"Foto: " + TextUtil.relaceQuotationMarks(firstImage.creditline)}
                </Typography>
            }
            if(firstImage.caption && full) {
                caption = <Typography
                    variant='title'
                    component='h3'
                    classes={{root: classes.caption}}
                >

                    {TextUtil.relaceQuotationMarks(firstImage.caption)}
                </Typography>;
            }
        }
        let teaser;
        let teaserLink;
        let teaserLinkPaddingBottom;
        if(full) {
            teaser = <Typography
                variant='title'
                component='h3'
                classes={{root: classes.teaser}}
            > {TextUtil.relaceQuotationMarks(this.getTeaser())}
            </Typography>;
        } else {
            teaser = <Typography
                variant='title'
                component='h3'
                classes={{root: classes.p}}
            > {TextUtil.relaceQuotationMarks(this.getTeaser())}
            </Typography>;
            teaserLink = <DpaLinkItem title={"Mehr lesen"} right={true} url={"/entry/" + entry.id}/>;
            teaserLinkPaddingBottom = <div style={{paddingBottom: 16}}/>;
        }

        let content = null;
        let kickerPadding = null;
        let contentPadding = null;
        let contentPaddingImage = <div style={{paddingBottom: 16}}/>;
        let contentPaddingImage2 = null;

        let date = null
        let note = null;
        let titleElement = null;
        let dateValue = null;
        if(full) {
            content = this.getContent(article,classes);
            contentPadding = <div style={{paddingBottom: 12}}/>;
            contentPaddingImage2 = <div style={{paddingBottom: 8}}/>;

            const locale = userLang ? userLang : DetectLocale.getPreferredLocale();
            const dateOptions = { month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit'};

            const {entry} = this.props;

            dateValue = new Date(Date.parse(entry.publish_from + " GMT"));
            if(!(dateValue instanceof Date && !isNaN(dateValue))) {
                let ds = entry.publish_from;
                ds = ds.replace(/-/g, "/");
                dateValue = new Date(Date.parse(ds + " GMT"));
            }

            let dateString = dateValue.toLocaleDateString(locale, dateOptions);
            dateString = dateString.replace(" um" , ",") + " Uhr";
            date = <Typography
                variant='title'
                component='h3'
                classes={{root: classes.creditline}}
            >
                {dateString}
            </Typography>

            note =<Typography
                variant='title'
                component='h3'
                classes={{root: classes.creditline}}
            >
                {"Hinweis: Dieser Text wurde automatisch von der Deutschen Presse-Agentur (dpa) übernommen und von unserer Redaktion nicht bearbeitet."}
            </Typography>

            titleElement = <Typography
                variant='title'
                component='h1'
                classes={{root: classes.title_h1}}
            >
                {title}
            </Typography>


        } else {
            kickerPadding = <div style={{paddingBottom: 16}}/>
            titleElement = <Typography
                variant='title'
                component='h1'
                classes={{root: classes.title_h2}}
            >
                {title}
            </Typography>;
            contentPaddingImage = <div style={{paddingBottom: 4}}/>;
        }

        if(title === "Bilder des Tages" && kicker === "") {
            return  this.renderPictureOfDay(titleElement, note, dateValue, article);
        }


        return (
            <div className={classes.quoteCard}>
                 {kickerPadding}
                <Typography
                    variant='title'
                    component='h2'
                    classes={{root: classes.kicker}}
                >
                    {kicker}
                </Typography>
                {contentPadding}
                {titleElement}
                {date}
                {contentPadding}
                <CardMedia
                    className={classes.cardMediaStyle}
                    image={this.getFirstImageUrl()}
                    component='img'

                />
                {contentPaddingImage}
                {caption}
                {contentPaddingImage2}
                {creditline}
                {contentPadding}
                {teaser}
                {teaserLink}
                {teaserLinkPaddingBottom}
                {content}
                {contentPadding}
                {note}
            </div>
        );
    }

    renderPictureOfDay(titleElement, note, dateValue, article) {
        const {classes, entry, userLang} = this.props;
        let contentPadding = <div style={{paddingBottom: 12}}/>;

        const locale = userLang ? userLang : DetectLocale.getPreferredLocale();
        const dateOptions = { month: 'long', day: 'numeric'};
        let dateString = dateValue.toLocaleDateString(locale, dateOptions);
        let date = <Typography
            variant='title'
            component='h3'
            classes={{root: classes.creditline}}
        >
            {dateString}
        </Typography>

        let content = [];
        for(let imageTile of entry.kacheln) {
            if(imageTile.type === "uestra/dpa-infoline-image") {
                content.push((<CardMedia
                    className={classes.cardMediaStyle}
                    image={imageTile.mediaURL}
                    component='img'
                />));
                content.push((<Typography
                    variant='title'
                    component='p'
                    classes={{root: classes.caption_inline}}
                >
                    {TextUtil.relaceQuotationMarks(imageTile.caption)}
                </Typography>));
                content.push((<Typography
                    variant='title'
                    component='p'
                    classes={{root: classes.creditline_inline}}
                >
                    {"Foto: " + TextUtil.relaceQuotationMarks(imageTile.creditline)}
                </Typography>));

            }
        }
        /*for(var part of _parts) {
            if (part.startsWith("<dnl-image")) {
                let urn = part.substring(part.indexOf("urn:"));
                urn = urn.substring(0, urn.indexOf('"'));
                let imageTile = this.getImageForUrn(urn);
            }
        }*/
        return (
            <div className={classes.quoteCard}>
                {contentPadding}
                {titleElement}
                {date}
                {contentPadding}
                {content}
                {contentPadding}
                {note}
            </div>
        );
    }

    getArticle() {
        const {entry} = this.props;
        for (var kachel of entry.kacheln) {
            if (kachel.type === "uestra/dpa-infoline-entry") {
                return kachel;
            }
        }
        return null;
    }

    getTeaser() {
        var article = this.getArticle();
        if (article) {
            return article.teaser ? article.teaser : article.title;
        }
    }

    getFirstImage() {
        const {entry,} = this.props;
        for (var image of entry.kacheln) {
            if (image.type === "uestra/dpa-infoline-image") {
                return image;
            }
        }
        return null;
    }

    getFirstImageUrl() {
        let image = this.getFirstImage();
        if (image && image.mediaURL) {
            return image.mediaURL;
        }
        return "";
    }

    getImageForUrn(urn) {
        const {entry,} = this.props;
        for (var image of entry.kacheln) {
            if (image.type === "uestra/dpa-infoline-image" && image.extID === urn) {
                return image;
            }
        }
        return null;
    }

    getContent(article, classes) {
        //const regexp = /<dnl-image.*?dnl-image>/g;

        //const array = [...article.article.matchAll(regexp)];


        //if(array.length === 0) {
         //   return (<div dangerouslySetInnerHTML={{__html: article.article}}/>);
        //}
        const html = article.article;
        const imgTagRegex = /<dnl-image.*?dnl-image>/g; // 'g' flag for global matching
        let lastIndex = 0;
        const _parts = [];

        let match;
        while ((match = imgTagRegex.exec(html)) !== null) {
            if (match.index > lastIndex) {
                _parts.push(html.substring(lastIndex, match.index));
            }
            _parts.push(match[0]); // match[0] is the matched string.
            lastIndex = imgTagRegex.lastIndex;
        }

        if (lastIndex < html.length) {
            _parts.push(html.substring(lastIndex));
        }

        if(_parts.length === 0) {
               return (<div dangerouslySetInnerHTML={{__html: article.article}}/>);
        }
        const result = [];
        for(var part of _parts) {
            if (part.startsWith("<dnl-image")) {
                let urn = part.substring(part.indexOf("urn:"));
                urn = urn.substring(0, urn.indexOf('"'));
                let imageTile = this.getImageForUrn(urn);
                if(imageTile) {
                    result.push((<CardMedia
                        className={classes.cardMediaStyle}
                        image={imageTile.mediaURL}
                        component='img'
                    />));
                    result.push((<Typography
                        variant='title'
                        component='p'
                        classes={{root: classes.caption_inline}}
                    >
                        {TextUtil.relaceQuotationMarks(imageTile.caption)}
                    </Typography>));
                    result.push((<Typography
                        variant='title'
                        component='p'
                        classes={{root: classes.creditline_inline}}
                    >
                        {"Foto: " + TextUtil.relaceQuotationMarks(imageTile.creditline)}
                    </Typography>));
                }

            } else {
                result.push((<div dangerouslySetInnerHTML={{__html: TextUtil.relaceQuotationMarks(part)}}/>));
            }

        }

        return result;

    }
}

DpaInfoCard.propTypes = {
    entry: PropTypes.object.isRequired,
    userLang: PropTypes.string,
    full: PropTypes.bool
};

export default function _DpaInfoCard(props) {
    const classes = useStyles();
    return <DpaInfoCard {...props} classes={classes}/>;
}
